module.exports = __webpack_public_path__ + "img/icon-differentials_07.b7185edd.svg";